<template>
  <div>
    <home-hero></home-hero>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import HomeHero from '@/components/HomeHero/HomeHero';

export default {
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      url: ''
    };
  },
  mounted() {},
  computed: {
    ...mapState(['userAgent'])
  },
  methods: {},
  components: {
    HomeHero
  }
};
</script>

<style scoped lang="scss">
</style>
